import React from 'react';
import PageShell from './PageShell';
import { servicesData, forestImage } from '../mock';
import { Cog, Truck, Factory, Leaf } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';

const icons = { progettazione: Cog, imballaggi: Truck, installazione: Factory, prefabbricazione: Leaf };

const ServiziPage = () => {
  const { t, lang } = useLang();
  return (
    <PageShell eyebrow={t('services.eyebrow')} title={t('services.title')} image={forestImage}>
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <p className="text-[#475569] leading-relaxed text-lg max-w-3xl">{t('services.body')}</p>

          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-8">
            {servicesData.map((s, i) => {
              const Icon = icons[s.id] || Cog;
              const c = s[lang] || s.en || s.it;
              return (
                <div key={s.id} className="flex gap-6 p-8 bg-[#f5f7fa] hover:bg-white hover:shadow-xl transition-all duration-300 border-l-2 border-[#c53114]">
                  <div className="w-14 h-14 rounded-full bg-[#0b2545] text-white flex items-center justify-center flex-shrink-0">
                    <Icon size={24} />
                  </div>
                  <div>
                    <p className="text-3xl text-[#c53114]/30 font-semibold" style={{ fontFamily: "'Barlow Condensed', 'Oswald', sans-serif" }}>
                      {String(i + 1).padStart(2, '0')}
                    </p>
                    <h3 className="text-2xl font-semibold text-[#0b2545]" style={{ fontFamily: "'Barlow Condensed', 'Oswald', sans-serif" }}>
                      {c.title}
                    </h3>
                    <p className="mt-3 text-[#475569] leading-relaxed">{c.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </PageShell>
  );
};

export default ServiziPage;
